export default "__VITE_ASSET__CC8qCwIN__"